$('.box-items__box').on('mouseenter', function () {
  $(this).find('.box-item').addClass('hover');
  $(this).prevAll().find('.box-item').addClass('hover');
  $(this).nextAll().find('.box-item').removeClass('hover');
});

$('.box-items__items').on('mouseleave', function () {
  $(this).find('.box-item').removeClass('hover');
});